/**
 * @generated SignedSource<<a33baf75f5aa3bad082d16cd65a4e38a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccount_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutACHForm_viewer">;
  readonly " $fragmentType": "CheckoutBankAccount_viewer";
};
export type CheckoutBankAccount_viewer$key = {
  readonly " $data"?: CheckoutBankAccount_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccount_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccount_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutACHForm_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "33f130a8efd25b17f534c8f0329dac2c";

export default node;
